import Plural from './plural';

export {
    Plural
};



// WEBPACK FOOTER //
// ./app/filters/index.js